import script from "./Tests.vue?vue&type=script&setup=true&lang=js"
export * from "./Tests.vue?vue&type=script&setup=true&lang=js"

import "./Tests.vue?vue&type=style&index=0&id=c0d64822&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/tests-frontend/tests-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0d64822"]])

export default __exports__